module.exports = __webpack_public_path__ + "static/legend_example-fc3717dd80eda78004adac32584aea04.png";